import React from 'react'
import type { ProofOfGamingProps } from '@/features/enrollment'

export default function ProofOfGaming({ enrollmentData, updateEnrollmentData, errors, proofOfGamingAutoSelected, setProofOfGamingAutoSelected }: ProofOfGamingProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-accent-900 mb-2">
        Do you have photos, witnesses, or any proof that video games were played/used? <span className="text-red-500">*</span>
      </label>
      
      {/* Auto-selection indicator */}
      {enrollmentData.proofOfGaming && enrollmentData.proofOfGaming.includes('Photos') && (
        <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-sm text-blue-800">
            <span className="font-medium">Auto-selected:</span>
            <span className="ml-2 text-blue-600 font-semibold">Photos</span>
          </p>
          <p className="text-xs text-blue-600 mt-1">
            You can uncheck Photos or select additional proof options below if needed.
          </p>
        </div>
      )}
      
      <div className="space-y-2">
        {['Photos', 'Witnesses', 'Other Proof'].map((proof) => (
          <label key={proof} className="flex items-center">
            <input 
              type="checkbox" 
              name="proofOfGaming"
              value={proof}
              checked={(enrollmentData.proofOfGaming || []).includes(proof)}
              onChange={(e) => {
                const currentProof = enrollmentData.proofOfGaming || []
                if (e.target.checked) {
                  updateEnrollmentData('proofOfGaming', [...currentProof, proof])
                } else {
                  updateEnrollmentData('proofOfGaming', currentProof.filter((p: string) => p !== proof))
                }
                // Prevent auto-selection from interfering with user changes
                if (!proofOfGamingAutoSelected) {
                  setProofOfGamingAutoSelected(true)
                }
              }}
              className="form-checkbox text-primary-600" 
            />
            <span className="ml-2 text-accent-700">{proof}</span>
          </label>
        ))}
      </div>
      {errors.proofOfGaming && (
        <p className="mt-1 text-sm text-red-600">{errors.proofOfGaming}</p>
      )}
    </div>
  )
}